import { render } from "./MainLogo.vue?vue&type=template&id=fbfb9c94&scoped=true"
import script from "./MainLogo.vue?vue&type=script&lang=js"
export * from "./MainLogo.vue?vue&type=script&lang=js"

import "./MainLogo.vue?vue&type=style&index=0&id=fbfb9c94&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbfb9c94"]])

export default __exports__